/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getNormativasGuardadas, exportarGuardadasExcel, quitarNormativaGuardada } from "../../../componentes/http/actions/DocumentoAction";
import { getClientesUsuario } from "../../../componentes/http/actions/UsuarioAction";
import { getEstadosSeguimientoUsuario } from "../../../componentes/http/actions/SeguimientoAction";
import {
  Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody,
  Typography, Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  TablePagination, useMediaQuery, useTheme, Card, CardContent, Button, CardActions,
  CircularProgress, Autocomplete, IconButton, Tooltip, Divider, InputAdornment, Stack, alpha,
} from "@mui/material";
import { jwtDecode } from "jwt-decode";
import DetalleNormativaClienteModal from "../../../componentes/modal/Normativa/DetalleNormativaClienteModal";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import SearchIcon from "@mui/icons-material/Search";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DownloadIcon from "@mui/icons-material/Download";
import DataLoaderCliente from "../../../componentes/data/DataLoaderCliente";
import { useNavigate } from "react-router-dom";
import SeguimientoNormativaModal from "../../../componentes/modal/Normativa/SeguimientoNormativaModal";
import { SeguimientoBadge, SeguimientoAccionButton } from "../../../componentes/navegacion/SeguimientoBadge";
import { SemaforoBadge, EstadoChip } from "../../../componentes/navegacion/SemaforoBadge";

const FILTERS_STORAGE_KEY = "gestorNormativaGuardadasFilters";

const saveFiltersToStorage = (filters) => {
  try { sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filters)); }
  catch (error) { console.error("Error al guardar filtros:", error); }
};

const loadFiltersFromStorage = () => {
  try {
    const saved = sessionStorage.getItem(FILTERS_STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed.startDate) parsed.startDate = new Date(parsed.startDate);
      if (parsed.endDate) parsed.endDate = new Date(parsed.endDate);
      return parsed;
    }
  } catch (error) { console.error("Error al cargar filtros:", error); }
  return null;
};

const formatFecha = (value) =>
  value ? new Date(value).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "";

const GestorNormativaGuardadas = () => {
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const idUsuario = decoded["oid"];

  const savedFilters = loadFiltersFromStorage();
  const navigate = useNavigate();

  const [serviciosDisponibles, setServiciosDisponibles] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [, setIsLoadingClientes] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [isLoadingNormativas, setIsLoadingNormativas] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [openDetalleModal, setOpenDetalleModal] = useState(false);
  const [normativaSeleccionado, setNormativaSeleccionado] = useState(null);
  const [openSeguimientoModal, setOpenSeguimientoModal] = useState(false);
  const [normativaSeguimiento, setNormativaSeguimiento] = useState(null);

  const [page, setPage] = useState(savedFilters?.page || 0);
  const [rowsPerPage, setRowsPerPage] = useState(savedFilters?.rowsPerPage || 10);

  const [searchTerm, setSearchTerm] = useState(savedFilters?.searchTerm || "");
  const [filterCliente, setFilterCliente] = useState(savedFilters?.filterCliente || "todos");
  const [filterEstadoSeguimiento, setFilterEstadoSeguimiento] = useState(savedFilters?.filterEstadoSeguimiento || "todos");
  const [startDate, setStartDate] = useState(savedFilters?.startDate || null);
  const [endDate, setEndDate] = useState(savedFilters?.endDate || null);

  const [clientes, setClientes] = useState([]);
  const [multipleClients, setMultipleClients] = useState(false);
  const [estadosSeguimiento, setEstadosSeguimiento] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const [loadedData, setLoadedData] = useState({
    organismos: [], tiposDocumento: [], estadosTramitacion: [], rubros: [],
    clasificaciones: [], clientes: [],
  });

  const [selectedFilters, setSelectedFilters] = useState(savedFilters?.selectedFilters || {
    organismo: null, tipoDocumento: null, estadoTramitacion: null, rubro: null,
  });

  const handleDataLoaded = useCallback((data) => {
    setLoadedData(data);
    if (savedFilters?.selectedFilters) {
      const restored = { ...savedFilters.selectedFilters };
      if (savedFilters.selectedFilters.organismo)
        restored.organismo = data.organismos.find((o) => o.id === savedFilters.selectedFilters.organismo.id) || null;
      if (savedFilters.selectedFilters.tipoDocumento)
        restored.tipoDocumento = data.tiposDocumento.find((t) => t.id === savedFilters.selectedFilters.tipoDocumento.id) || null;
      if (savedFilters.selectedFilters.estadoTramitacion)
        restored.estadoTramitacion = data.estadosTramitacion.find((e) => e.id === savedFilters.selectedFilters.estadoTramitacion.id) || null;
      if (savedFilters.selectedFilters.rubro)
        restored.rubro = data.rubros.find((r) => r.id === savedFilters.selectedFilters.rubro.id) || null;
      setSelectedFilters(restored);
    }
  }, []);

  useEffect(() => {
    const filtersToSave = { searchTerm, filterCliente, filterEstadoSeguimiento, startDate, endDate, page, rowsPerPage, selectedFilters };
    saveFiltersToStorage(filtersToSave);
  }, [searchTerm, filterCliente, filterEstadoSeguimiento, startDate, endDate, page, rowsPerPage, selectedFilters]);

  const getServiceIcon = (servicio) => {
    switch (servicio) {
      case "Compromisos": return <AssignmentOutlinedIcon fontSize="small" />;
      case "Obligaciones": return <TaskAltOutlinedIcon fontSize="small" />;
      case "Enlace Resumen": return <AccountBalanceOutlinedIcon fontSize="small" />;
      default: return <AssignmentOutlinedIcon fontSize="small" />;
    }
  };

  const handleVerServicio = (servicio, idNormativa) => {
    const rutaServicio = servicio.toLowerCase().replace(" ", "-");
    navigate(`/usuario/${rutaServicio}/normativa/${idNormativa}`);
  };

  useEffect(() => { fetchClientes(); }, []);
  useEffect(() => { setMultipleClients(clientes && clientes.length > 1); }, [clientes]);

  useEffect(() => {
    if (clientes && clientes.length > 0) {
      const serviciosUnicos = clientes.reduce((servicios, cliente) => {
        if (cliente.servicios && Array.isArray(cliente.servicios)) {
          cliente.servicios.forEach((s) => { if (!servicios.includes(s)) servicios.push(s); });
        }
        return servicios;
      }, []);
      setServiciosDisponibles(serviciosUnicos);
    }
  }, [clientes]);

  useEffect(() => {
    if (serviciosDisponibles.includes("Seguimiento")) {
      getEstadosSeguimientoUsuario(token, idUsuario)
        .then((resp) => setEstadosSeguimiento(resp?.items && Array.isArray(resp.items) ? resp.items : []))
        .catch(() => setEstadosSeguimiento([]));
    }
  }, [serviciosDisponibles]);

  const estadosSeguimientoOpciones = useMemo(() => {
    const vistos = new Set();
    return [...estadosSeguimiento]
      .sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0))
      .filter((e) => {
        const nombre = (e.nombre || "").trim().toLowerCase();
        if (!nombre || vistos.has(nombre)) return false;
        vistos.add(nombre);
        return true;
      });
  }, [estadosSeguimiento]);

  const fetchNormativasGuardadas = useCallback(() => {
    setIsLoadingNormativas(true);
    const filtros = {
      searchTerm,
      organismo: selectedFilters.organismo?.nombre || null,
      tipoDocumento: selectedFilters.tipoDocumento?.nombre || null,
      estadoTramitacion: selectedFilters.estadoTramitacion?.nombre || null,
      cliente: filterCliente !== "todos" ? filterCliente : null,
      rubro: selectedFilters.rubro?.nombre || null,
      estadoSeguimiento: filterEstadoSeguimiento !== "todos" ? filterEstadoSeguimiento : null,
      fechaDesde: startDate, fechaHasta: endDate,
    };
    getNormativasGuardadas(token, idUsuario, page + 1, rowsPerPage, filtros)
      .then((response) => {
        if (response?.items && Array.isArray(response.items)) {
          setDocumentos(response.items);
          setTotalCount(response.totalCount || 0);
        } else { setDocumentos([]); setTotalCount(0); }
      })
      .catch((error) => { console.error("Error al cargar guardadas:", error); setDocumentos([]); setTotalCount(0); })
      .finally(() => { setIsLoadingNormativas(false); setInitialLoadComplete(true); });
  }, [page, rowsPerPage, searchTerm, filterCliente, filterEstadoSeguimiento, selectedFilters, startDate, endDate, token, idUsuario]);

  useEffect(() => { fetchNormativasGuardadas(); }, [fetchNormativasGuardadas]);

  const handleFilterChange = (field, value) => { setSelectedFilters((p) => ({ ...p, [field]: value })); setPage(0); };

  const fetchClientes = () => {
    setIsLoadingClientes(true);
    getClientesUsuario(token, idUsuario)
      .then((response) => setClientes(response && Array.isArray(response) ? response : []))
      .catch(() => setClientes([]))
      .finally(() => setIsLoadingClientes(false));
  };

  const handleChangePage = (e, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); };
  const handleOpenDetalleModal = useCallback((n) => { setNormativaSeleccionado(n); setOpenDetalleModal(true); }, []);
  const handleCloseDetalleModal = useCallback(() => { setOpenDetalleModal(false); setNormativaSeleccionado(null); }, []);

  const handleOpenSeguimiento = useCallback((n) => {
    setNormativaSeguimiento(n);
    setOpenSeguimientoModal(true);
  }, []);

  const handleCloseSeguimiento = useCallback(() => {
    setOpenSeguimientoModal(false);
    setNormativaSeguimiento(null);
  }, []);

  const handleSeguimientoActualizado = useCallback(() => {
    fetchNormativasGuardadas();
  }, [fetchNormativasGuardadas]);

  const handleExportarExcel = () => {
    setIsDownloading(true);
    const filtros = {
      nombre: searchTerm,
      organismo: selectedFilters.organismo?.nombre || null,
      tipoDocumento: selectedFilters.tipoDocumento?.nombre || null,
      estadoTramitacion: selectedFilters.estadoTramitacion?.nombre || null,
      cliente: filterCliente !== "todos" ? filterCliente : null,
      rubro: selectedFilters.rubro?.nombre || null,
      estadoSeguimiento: filterEstadoSeguimiento !== "todos" ? filterEstadoSeguimiento : null,
      fechaDesde: startDate, fechaHasta: endDate,
    };
    exportarGuardadasExcel(token, idUsuario, filtros)
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `NormativasGuardadas_${new Date().toISOString().slice(0, 10)}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Error al exportar Excel:", error))
      .finally(() => setIsDownloading(false));
  };

  const handleSearchTermChange = (e) => { setSearchTerm(e.target.value); setPage(0); };
  const handleClienteFilterChange = (e) => { setFilterCliente(e.target.value); setPage(0); };
  const handleEstadoSeguimientoChange = (e) => { setFilterEstadoSeguimiento(e.target.value); setPage(0); };
  const handleStartDateChange = (v) => { setStartDate(v); setPage(0); };
  const handleEndDateChange = (v) => { setEndDate(v); setPage(0); };

  const handleResetFilters = () => {
    setStartDate(null); setEndDate(null); setSearchTerm(""); setFilterCliente("todos");
    setFilterEstadoSeguimiento("todos");
    setSelectedFilters({ organismo: null, tipoDocumento: null, estadoTramitacion: null, rubro: null });
    setPage(0);
    sessionStorage.removeItem(FILTERS_STORAGE_KEY);
  };

  const handleQuitar = (documento) => {
    quitarNormativaGuardada(token, idUsuario, documento.id)
      .then(() => fetchNormativasGuardadas())
      .catch((error) => console.error("Error al quitar:", error));
  };

  const clienteActivoId = useMemo(
    () => (filterCliente !== "todos" ? clientes.find((c) => c.nombre === filterCliente)?.id : null),
    [filterCliente, clientes]
  );

  const renderNoDataMessage = () => (
    <Paper sx={{ p: 5, textAlign: "center" }}>
      <Typography variant="subtitle1" sx={{ mb: 0.5 }}>Sin resultados</Typography>
      <Typography variant="body2" color="text.secondary">
        No tienes normativas guardadas que coincidan con los filtros actuales. Ajusta la búsqueda o límpiala para ver todo.
      </Typography>
      <Button onClick={handleResetFilters} sx={{ mt: 2 }} variant="outlined" size="small">
        Limpiar filtros
      </Button>
    </Paper>
  );

  const tableColumns = useMemo(() => {
    const cols = [
      { id: "nombre", label: "Nombre", minWidth: 220, maxWidth: 320 },
      { id: "organismoEmisor", label: "Organismo", minWidth: 120, hideOnBreakpoint: "md" },
      { id: "tipoDocumento", label: "Tipo", minWidth: 120, hideOnBreakpoint: "md" },
      { id: "estadoTramitacion", label: "Estado", minWidth: 130, format: (v) => <EstadoChip estado={v} /> },
      { id: "fechaPublicacion", label: "Fecha ", minWidth: 110, format: formatFecha, tooltip: "Fecha de publicación de una norma" },
      { id: "vigencia", label: "Vigencia", minWidth: 110, hideOnBreakpoint: "md" },
    ];
    if (multipleClients) {
      cols.push({
        id: "clientes", label: "Clientes", minWidth: 150, hideOnBreakpoint: "md",
        format: (v) => (v && Array.isArray(v) ? v.map((c) => c.nombre).join(", ") : ""),
      });
    }
    if (serviciosDisponibles.includes("Compromisos")) {
      cols.push({
        id: "compromisos", label: "Compromisos", minWidth: 110, align: "center", hideOnBreakpoint: "md",
        format: (v, doc) => <SemaforoBadge cantidad={v && Array.isArray(v) ? v.length : 0} documento={doc} tipo="Compromisos" />,
      });
    }
    if (serviciosDisponibles.includes("Obligaciones")) {
      cols.push({
        id: "obligaciones", label: "Obligaciones", minWidth: 110, align: "center", hideOnBreakpoint: "md",
        format: (v, doc) => <SemaforoBadge cantidad={v && Array.isArray(v) ? v.length : 0} documento={doc} tipo="Obligaciones" />,
      });
    }
    if (serviciosDisponibles.includes("Seguimiento")) {
      cols.push({
        id: "seguimientoInfo",
        label: "Seguimiento",
        minWidth: 150,
        hideOnBreakpoint: "md",
        format: (v, doc) => <SeguimientoBadge seguimientoInfo={v} idCliente={clienteActivoId} onClick={() => handleOpenSeguimiento(doc)} />,
      });
    }
    cols.push({ id: "acciones", label: "Acciones", minWidth: Math.max(160, serviciosDisponibles.length * 40), align: "right" });
    return cols;
  }, [multipleClients, serviciosDisponibles, clienteActivoId, handleOpenSeguimiento]);

  const visibleColumns = useMemo(
    () => tableColumns.filter((c) => !(c.hideOnBreakpoint === "md" && isSmall)),
    [tableColumns, isSmall]
  );

  const renderServiceButtons = (documento, mobile = false) => {
    const serviciosOcultos = ["semaforo", "enlaceresumen", "integracion austranetgrc", "seguimiento", "compromisos", "obligaciones", "impacto"];
    const serviciosMostrar = serviciosDisponibles.filter(
      (s) => !serviciosOcultos.includes(s.toLowerCase())
    );
    return serviciosMostrar.map((servicio) => {
      const onClick = () => handleVerServicio(servicio, documento.id);
      if (mobile) {
        return (
          <Button key={servicio} size="small" variant="outlined" onClick={onClick} startIcon={getServiceIcon(servicio)}>
            {servicio}
          </Button>
        );
      }
      return (
        <Tooltip key={servicio} title={`Ver ${servicio.toLowerCase()}`}>
          <IconButton size="small" color="primary" onClick={onClick}>{getServiceIcon(servicio)}</IconButton>
        </Tooltip>
      );
    });
  };

  const renderMobileCard = (documento) => (
    <Card key={documento.id} elevation={1} sx={{ mb: 1.5 }}>
      <CardContent sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1, mb: 1 }}>
          <Typography variant="subtitle2" sx={{ wordBreak: "break-word", flex: 1 }}>{documento.nombre}</Typography>
          <EstadoChip estado={documento.estadoTramitacion} />
        </Box>
        <Divider sx={{ my: 1 }} />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Organismo</Typography>
            <Typography variant="body2">{documento.organismoEmisor}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Tipo</Typography>
            <Typography variant="body2">{documento.tipoDocumento}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">Publicación</Typography>
            <Typography variant="body2">{formatFecha(documento.fechaPublicacion)}</Typography>
          </Grid>
          {serviciosDisponibles.includes("Seguimiento") && (
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">Seguimiento</Typography>
              <Box><SeguimientoBadge seguimientoInfo={documento.seguimientoInfo} idCliente={clienteActivoId} onClick={() => handleOpenSeguimiento(documento)} /></Box>
            </Grid>
          )}
          {multipleClients && (
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary">Clientes</Typography>
              <Typography variant="body2">
                {documento.clientes && Array.isArray(documento.clientes) ? documento.clientes.map((c) => c.nombre).join(", ") : ""}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2, flexWrap: "wrap", gap: 1 }}>
        <Button variant="contained" size="small" onClick={() => handleOpenDetalleModal(documento)} startIcon={<VisibilityOutlinedIcon />}>
          Detalle
        </Button>
        {documento.url && (
          <Button variant="outlined" size="small" component="a" href={documento.url} target="_blank" rel="noopener noreferrer" startIcon={<DescriptionOutlinedIcon />}>
            Documento
          </Button>
        )}
        {renderServiceButtons(documento, true)}
        {serviciosDisponibles.includes("Seguimiento") && (
          <Button variant="outlined" size="small" onClick={() => handleOpenSeguimiento(documento)} startIcon={<FactCheckOutlinedIcon />}>
            Seguimiento
          </Button>
        )}
        <Button variant="outlined" color="error" size="small" onClick={() => handleQuitar(documento)} startIcon={<BookmarkRemoveIcon />}>
          Quitar
        </Button>
      </CardActions>
    </Card>
  );

  return (
    <Box sx={{ pt: { xs: 2.5, sm: 1.5 }, pb: 4 }}>
      <DataLoaderCliente onDataLoaded={handleDataLoaded} />

      <Box sx={{ mb: 3 }}>
        <Typography variant="h5">Mis normas / Guardados</Typography>
        <Typography variant="body2" color="text.secondary">
          Consulta, filtra y administra las normativas que has guardado.
        </Typography>
      </Box>

      <Paper elevation={1} sx={{ p: { xs: 2, sm: 2.5 }, mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, textTransform: "uppercase", letterSpacing: "0.04em", fontSize: "0.72rem" }}>
          Filtros de búsqueda
        </Typography>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <TextField
              fullWidth label="Buscar por nombre o código" value={searchTerm} onChange={handleSearchTermChange}
              InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon fontSize="small" color="disabled" /></InputAdornment>) }}
            />
          </Grid>
          {multipleClients && (
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth>
                <InputLabel>Cliente</InputLabel>
                <Select value={filterCliente} onChange={handleClienteFilterChange} label="Cliente">
                  <MenuItem value="todos">Todos</MenuItem>
                  {clientes.map((c) => (<MenuItem key={c.id} value={c.nombre}>{c.nombre}</MenuItem>))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.organismos || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Organismo emisor" />}
              value={selectedFilters.organismo} onChange={(e, v) => handleFilterChange("organismo", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.tiposDocumento || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Tipo de documento" />}
              value={selectedFilters.tipoDocumento} onChange={(e, v) => handleFilterChange("tipoDocumento", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.estadosTramitacion || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Estado de tramitación" />}
              value={selectedFilters.estadoTramitacion} onChange={(e, v) => handleFilterChange("estadoTramitacion", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete options={loadedData.rubros || []} getOptionLabel={(o) => o.nombre || ""}
              renderInput={(p) => <TextField {...p} label="Rubro" />}
              value={selectedFilters.rubro} onChange={(e, v) => handleFilterChange("rubro", v)}
              isOptionEqualToValue={(o, v) => o.id === v?.id} />
          </Grid>
          {serviciosDisponibles.includes("Seguimiento") && (
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Autocomplete options={estadosSeguimientoOpciones} getOptionLabel={(o) => o.nombre || ""}
                renderInput={(p) => <TextField {...p} label="Estado de seguimiento" />}
                value={estadosSeguimientoOpciones.find((e) => e.nombre === filterEstadoSeguimiento) || null}
                onChange={(e, v) => handleEstadoSeguimientoChange({ target: { value: v ? v.nombre : "todos" } })}
                isOptionEqualToValue={(o, v) => o.id === v?.id} />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker sx={{ width: "100%" }} format="dd/MM/yyyy" label="Fecha desde"
                value={startDate} onChange={handleStartDateChange} slotProps={{ textField: { size: "small" } }} />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker sx={{ width: "100%" }} format="dd/MM/yyyy" label="Fecha hasta"
                value={endDate} onChange={handleEndDateChange} slotProps={{ textField: { size: "small" } }} />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Stack direction="row" spacing={1.5} sx={{ mt: 2.5 }}>
          <Button variant="outlined" onClick={handleResetFilters}>Limpiar filtros</Button>
          <Button variant="contained" color="success" onClick={handleExportarExcel} startIcon={<DownloadIcon />} disabled={isDownloading}>
            {isDownloading ? <CircularProgress size={20} color="inherit" /> : "Exportar Excel"}
          </Button>
        </Stack>
      </Paper>

      {(!initialLoadComplete || isLoadingNormativas) ? (
        <Box display="flex" justifyContent="center" p={5}><CircularProgress /></Box>
      ) : documentos && documentos.length > 0 ? (
        <>
          {isMobile ? (
            <Box>{documentos.map(renderMobileCard)}</Box>
          ) : (
            <TableContainer component={Paper} elevation={1} sx={{ overflow: "auto" }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {visibleColumns.map((column) => (
                      <TableCell key={column.id} align={column.align || "left"} sx={{ minWidth: column.minWidth, py: 1.25, px: 2, whiteSpace: "nowrap" }}>
                        {column.tooltip ? (
                          <Tooltip title={column.tooltip} arrow>
                            <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, cursor: "help" }}>
                              {column.label}
                            </Box>
                          </Tooltip>
                        ) : (
                          column.label
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {documentos.map((documento) => (
                    <TableRow key={documento.id} hover sx={{ "&:hover": { backgroundColor: (t) => alpha(t.palette.primary.main, 0.04) } }}>
                      {visibleColumns.map((column) => {
                        if (column.id === "acciones") {
                          return (
                            <TableCell key={column.id} align="right" sx={{ px: 1.5 }}>
                              <Stack direction="row" spacing={0.25} justifyContent="flex-end">
                                <Tooltip title="Ver detalle">
                                  <IconButton size="small" color="primary" onClick={() => handleOpenDetalleModal(documento)}>
                                    <VisibilityOutlinedIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                {documento.url && (
                                  <Tooltip title="Ver documento">
                                    <IconButton size="small" color="primary" component="a" href={documento.url} target="_blank" rel="noopener noreferrer">
                                      <DescriptionOutlinedIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                                {renderServiceButtons(documento, false)}
                                {serviciosDisponibles.includes("Seguimiento") && (
                                  <SeguimientoAccionButton
                                    seguimientoInfo={documento.seguimientoInfo}
                                    idCliente={clienteActivoId}
                                    onClick={() => handleOpenSeguimiento(documento)}
                                  />
                                )}
                                <Tooltip title="Quitar de guardados">
                                  <IconButton size="small" color="error" onClick={() => handleQuitar(documento)}>
                                    <BookmarkRemoveIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                            </TableCell>
                          );
                        }
                        const value = documento[column.id];
                        return (
                          <TableCell
                            key={column.id} align={column.align || "left"}
                            sx={{
                              py: 1.25, px: 2,
                              maxWidth: column.id === "nombre" ? 320 : 160,
                              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                              fontWeight: column.id === "nombre" ? 600 : 400,
                            }}
                          >
                            {column.format ? column.format(value, documento) : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]} component="div" count={totalCount}
            rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Filas por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          />
        </>
      ) : (
        renderNoDataMessage()
      )}

      {openDetalleModal && (
        <DetalleNormativaClienteModal 
          open={openDetalleModal} 
          onClose={handleCloseDetalleModal}
          normativa={normativaSeleccionado} 
          isLoading={isLoadingNormativas}
          mostrarImpacto={serviciosDisponibles.includes("Impacto")} 
        />
      )}

      {openSeguimientoModal && (
        <SeguimientoNormativaModal
          open={openSeguimientoModal}
          onClose={handleCloseSeguimiento}
          token={token}
          idUsuario={idUsuario}
          normativa={normativaSeguimiento}
          clientesUsuario={clientes}
          onSeguimientoActualizado={handleSeguimientoActualizado}
        />
      )}
    </Box>
  );
};

export default GestorNormativaGuardadas;